import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../../translation";
import Notification from "../../Notification";

const mapProductToMessage = {
  Product: "reservation_message",
  Subscription: "subscription_confirmation_message",
  Voucher: "voucher_confirmation_message"
};

const mapSellerChangedProductToMessage = {
  Product: "dtc_atb_reservation_sellerchangemessage"
};

const getMessage = (sellerChanged, items) => {
  return sellerChanged
    ? mapSellerChangedProductToMessage[items[0].itemType]
    : `minibag_${mapProductToMessage[items[0].itemType]}`;
};

const ReservationMessage = ({
  items,
  sellerChanged,
  formatTranslation,
  displayReservationMessage
}) =>
  displayReservationMessage && (
    <Notification type="success">
      {formatTranslation(getMessage(sellerChanged, items))}
    </Notification>
  );

ReservationMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  displayReservationMessage: PropTypes.bool,
  sellerChanged: PropTypes.bool,
  items: PropTypes.array
};

ReservationMessage.defaultProps = {
  displayReservationMessage: false
};

export default withTranslation(ReservationMessage);
